export default __webpack_public_path__ + "static/media/retro.cdacf559.ttf";